<template>
  <div class="d-flex flex-column align-start justify-start nested-dropdown">
    <!-- We recursively call this component to build the nested dropdown -->
    <DpplNestedDropdown
      v-for="({
        name: childName,
        label: childLabel,
        onClick: childOnClick,
        children: childChildren,
        hasDivider: childHasDivider,
        prependIcon: childPrependIcon,
        prependIconClass: childPrependIconClass,
        attributes: childAttributes,
        href: childHref,
      }) in children"
      :key="childName"
      :label="childLabel"
      :on-click="childOnClick"
      :children="childChildren"
      :has-divider="childHasDivider"
      :prepend-icon="childPrependIcon"
      :prepend-icon-class="childPrependIconClass"
      :attributes="childAttributes"
      :href="childHref"
    />
  </div>
</template>

<script setup>
import DpplNestedDropdown from '@/components/datapeople/DpplNestedDropdown/DpplNestedDropdown.vue';

defineProps({
  children: {
    type: Array,
    default() {
      return [];
    },
  },
});
</script>
